// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import { Input, Tabs as SheetsTabs } from 'sonata-react-components';

import { DocumentSettings } from '../DocumentSettings';
import { useReportDownloadSectionContext } from '../ReportDownloadSection.context';
import { Tabs } from '../Tabs';
import { ReportDownloadFormStyled } from './ReportDownloadForm.style';

function ReportDownloadForm() {
  const { formatMessage } = useIntl();
  const { createTab, deleteTab, editTabName, getTabOptions, name, setName, setType, tabsIds, type } =
    useReportDownloadSectionContext();

  const sheetTabs = tabsIds.map((id: string) => {
    const options = getTabOptions(id);
    return {
      component: <DocumentSettings id="DocumentSettings" tabId={id} />,
      id,
      title: options.sheetName
    };
  });

  return (
    <ReportDownloadFormStyled className="reportDownloadForm">
      <div className="reportDownloadForm__title textTitle">
        {formatMessage({
          defaultMessage: 'Set Format',
          id: 'reporting.reportingDownload.setFormat'
        })}
      </div>
      <Input
        id="nameInput-reportDownloadForm"
        label={formatMessage({
          defaultMessage: 'Name',
          id: 'reporting.reportingDownload.nameInputLabel'
        })}
        name="name"
        onChange={value => setName(value as string)}
        shape="squareUI"
        type="text"
        value={name}
      />
      <Tabs defaultTabId={type} onTabClick={setType}>
        <Tabs.Item icon="far fa-file-csv" id="excel" title="Excel">
          <div className="reportDownloadForm__section">
            <div className="reportDownloadForm__title textTitle">
              {formatMessage({
                defaultMessage: 'Document Settings',
                id: 'reporting.documentSettings.title'
              })}
            </div>
            <SheetsTabs
              className="reportDownloadForm__settingsSection"
              initialTab={tabsIds[0]}
              key={tabsIds.join(',')}
              onCreateTab={createTab}
              onDeleteTab={deleteTab}
              onEditTabText={editTabName}
              shape="narrow"
              showDeleteAction={tabsIds.length > 1}
              showEditTitle
              tabs={sheetTabs}
              withEmptyTitle={false}
            />
          </div>
        </Tabs.Item>
        <Tabs.Item icon="far fa-file-csv" id="csv" title=".CSV">
          <div className="reportDownloadForm__section">
            <div className="reportDownloadForm__title">
              {formatMessage({
                defaultMessage: 'Document Settings',
                id: 'reporting.documentSettings.title'
              })}
            </div>
            <div className="reportDownloadForm__settingsSection">
              <DocumentSettings id="DocumentSettings" tabId={tabsIds[0]} />
            </div>
          </div>
        </Tabs.Item>
      </Tabs>
    </ReportDownloadFormStyled>
  );
}

export default ReportDownloadForm;
